// Lucide "download" line icon, inlined — this app has no icon dependency and
// follows the existing inline-SVG convention (stroke=currentColor line icons).
// Source: lucide.dev/icons/download (ISC-licensed).

interface DownloadIconProps {
  className?: string;
  size?: number;
}

export function DownloadIcon({ className, size = 16 }: DownloadIconProps) {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
      <polyline points="7 10 12 15 17 10" />
      <line x1="12" x2="12" y1="15" y2="3" />
    </svg>
  );
}
